/*
contact-form.validate.js
Written by Don Johnson 5/14/15
Updated 7/28/21 to handle Shopify's new implementation of Captcha

validates a Shopify form using the jQuery Validate plugin
*/

$().ready(function() {
  // "submit" button must be outside of form to prevent conflict with captcha
  // here, we bind form validation to this button, and allow button to submit the form if valid
  $('#validate-then-submit-button').on('click', function() {
    if ( $("#contact_form").valid() ) {
      $("div.error").hide();
      $("#contact_form").submit()
    }
  });
  
  // don't allow "enter" key to submit form
  $('#contact_form input').keydown(function (e) {
    if (e.keyCode == 13) {
        e.preventDefault();
        return false;
    }
  });
  
  // define validation handler
  $("#contact_form").validate({
    invalidHandler: function(event, validator) {
      // 'this' refers to the form
      var errors = validator.numberOfInvalids();
      if (errors) {
        var message = errors == 1
          ? 'You missed 1 field. It has been highlighted. Please review and try again.'
          : 'You missed ' + errors + ' fields. They have been highlighted. Please review and try again.';
        $("div.error span").html(message);
        $("div.error").show();
      } else {
        $("div.error").hide();
      }
    },
    errorPlacement: function(error, element) {
      error.insertBefore(element);
    },
    rules: {
      "contact[name]": {
        required: true
      },
      "contact[email]": {
        required: true,
        email: true
      },
      "contact[email_check]": {
        equalTo: "#contactFormEmail"
      },
      "contact[body]": {
        required: true
      }
    },
    messages: {
      "contact[name]": {
        required: "Please enter your name"
      },
      "contact[email]": {
        required: "Please enter your email address",
        email: "Please enter a valid email address"
      },
      "contact[email_check]": {
        required: "Please enter your email address",
        email: "Please enter a valid email address",
        equalTo: "Your email addresses do not match"
      },
      "contact[body]": {
        required: "Please enter your message"
      }
    }
  });
});
